"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCountryList, setPropertyList } from "@/store/slices/inquirySlice";
import api from "@/helper/api.interceptor";

export default function InitReduxFromServer({ countryList, propertylist }) {
  const dispatch = useDispatch();
  const pathname = usePathname();

  useEffect(() => {
    if (countryList) {
      let CountryList = countryList.filter(
        (country) => country.phonecode !== "92",
      );
      dispatch(setCountryList(CountryList));
    }
  }, [countryList, dispatch]);

  // property list fetch only once
  useEffect(() => {
    if (propertylist) {
      dispatch(setPropertyList(propertylist));
    }
  }, [propertylist, dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
